export const localStorageItem = (state, key) => state.localStorage[key];
export const localStorageIsLoaded = (state) => !!state.localStorage.isLoaded;
export const localStorageItems = (state) => state.localStorage;
